import React from 'react';
import { Link } from 'react-router-dom'
import { StyledEmptyList, EmptyText } from './styledComponents';

import Icon from 'components/Icon';
import Button from 'components/Button';

// `blocked` and `openResubscribeModal` come from ChannelList — this stays a
// dumb component. When the account's subscription has ended the CTA is a Button
// opening the resubscribe prompt rather than a Link to the form: an empty list
// is exactly where "make your first channel!" is most inviting, and following
// it would land on a form the server will not accept.
const EmptyList = ({ blocked, openResubscribeModal }) => (
  <StyledEmptyList>
    <Icon
      className='channel-list__empty-icon'
      size='140'
      name='channels'
    />
    <EmptyText>
      It’s looking empty around here…
    </EmptyText>
    {blocked
      ? <Button onClick={openResubscribeModal}>Make your first channel!</Button>
      : (
        <Link to='/channels/new'>
          <Button>Make your first channel!</Button>
        </Link>
      )}
  </StyledEmptyList>
);

export default EmptyList;
